import { Page } from './types'
import Source from '../components/Source'
import { VersionFolder, VersionStr } from '../logic/Versions'

type InstallEngineProps = {
    os: string
}

type OSInstructions = () => JSX.Element

const labels : Record<string, OSInstructions> = {
    'windows': () => <>
        <li>Download the MSI installer for <i>x64 Windows</i>.</li>
        <li>Run the installer to install Gurobi.</li>
    </>,
    'linux': () => 
    <>
        <li>Download the TAR.GZ package for <i>x64 Linux</i>.</li>
        <li> Your next step is to choose a destination directory. We recommend <code>/opt</code> for a shared installation
            (assuming you have sudo privileges to write in that directory), or your home directory for a private installation,
            but other directories will work as well.</li>
        <li>You'll need to change your working directory to the destination directory
            (e.g., cd <code>/opt</code> or <code>cd /home/jones</code>), then copy the Gurobi distribution to that directory,
            and then extract the contents: <code>tar xvfz gurobi{VersionStr}_linux64.tar.gz</code> ; This command will create a sub-directory
            <code>/gurobi{VersionFolder}/linux64</code> that contains the complete Gurobi distribution. Your <code>&lt;installdir&gt;</code>
            (which we'll refer to later) will be <code>/opt/gurobi{VersionFolder}/linux64</code>. 
        </li>
        <li>
            The Gurobi Optimizer makes use of several executable files. In order to allow these files to be found when needed,
            you will have to modify a few environment variables:
            <ul>
                <li><code>GUROBI_HOME</code> should point to your <code>&lt;installdir&gt;</code></li>
                <li><code>PATH</code> should be extended to include <code>&lt;installdir&gt;/bin</code></li>
                <li><code>LD_LIBRARY_PATH</code> should be extended to include <code>&lt;installdir&gt;/lib</code></li>
            </ul>
        </li>
    </>,
    'macos': () => <>
        <li>Download the PKG package for <i>MacOS Universal2</i></li>
        <li> By default, the installer will place the Gurobi files in <code>/Library/gurobi{VersionFolder}/macos_universal2</code>
         (note that this is the system <code>/Library</code> directory, not your personal <code>~/Library directory</code>). Your 
         <code>&lt;installdir&gt;</code> (which we'll refer to throughout this document) will be <code>/Library/gurobi{VersionFolder}/macos_universal2</code>. </li>
    </>
}

const render = ({ os }: InstallEngineProps) => {
    return <>
        <ul>
            <li>Go to our <a href="https://www.gurobi.com/downloads/gurobi-software/">downloads page</a>.</li>
            <li>Look for the section <i>Current Versions</i>, <i>Gurobi Optimizer</i>.</li>
            {labels[os]()}
        </ul>
        <Source href="https://www.gurobi.com/documentation/{version}/quickstart_linux/software_installation_guid.html#section:Installation"/>
    </>
}


const InstallEngine : Page<InstallEngineProps> = { key: 'install-engine', title: 'Installing the Gurobi software', render }

export default InstallEngine